// extracted by mini-css-extract-plugin
export default {"fieldset":"TariffBlock_fieldset__oWNCw","caretDown":"TariffBlock_caretDown__uylrk","tabsContainer":"TariffBlock_tabsContainer__y-Lgr","tabItem":"TariffBlock_tabItem__Jw8cf"};